import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AccountType } from "../types/loadedData";

interface UserState {
  account: AccountType | null;
  token: string | null;
}

const initialState: UserState = {
  token: null,
  account: null,
};

export const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string | null>) => {
      state.token = action.payload;
    },

    setAccount: (state, action: PayloadAction<AccountType | null>) => {
      state.account = action.payload;
    },
  },
});

export const { setToken, setAccount } = accountSlice.actions;

export default accountSlice.reducer;
